import useSWR from 'swr';
import { getRequest, postRequest, patchRequest, deleteRequest } from '../utils/request';

export const getProducts = async (queryParams) => getRequest(`/product`, queryParams);
export const GetProducts = queryParams => useSWR(() => !queryParams?.revoke ? [`/product`, queryParams] : null, getRequest)

export const getProductById = async (id) => getRequest(`/product/${id}`);
export const GetProductById = id => useSWR(() => id ? `/product/${id}` : null, getRequest)

export const postProduct = async (data) => postRequest(`/product`, data);

export const patchProduct = async (id, data) => patchRequest(`/product/${id}`, data);

export const deleteProduct = async (id) => deleteRequest(`/product/${id}`);

export const uploadProductImages = async (productId, data) => postRequest(`/product/upload-images/${productId}`, data);

export const deleteProductFile = async (productId, fileId) => deleteRequest(`/product/upload-images/${productId}/${fileId}`);
